import React, { useState } from "react";
import {
    Modal,
    Box,
    Button,
    Grid,
    Typography,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import ExploreIcon from '@mui/icons-material/Explore';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import GoalOptionCard from "../Card";
import buttonText from "assets/theme/components/button/text";


const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 1000,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: 3,
    p: 4,
};

const goalOptions = [
    {
        label: "EXPLORE",
        value: "explore",
        icon: <ExploreIcon fontSize="large" />,
        description: "Begin your journey with a brief introduction to key concepts and a quick assessment.",
        buttonText: "Start Learning",
    },
    {
        label: "EXPERIENCE",
        value: "experience",
        icon: <BuildCircleIcon fontSize="large" />,
        description: "Gain a deeper understanding with balanced content and a moderately detailed assessment.",
        buttonText: "Build Proficiency",
    },
    {
        label: "EXCEL",
        value: "excel",
        icon: <MilitaryTechIcon fontSize="large" />,
        description: "Master the material through comprehensive learning and a challenging assessment.",
        buttonText: "Achieve Excellence",
    },
];



const CourseGoalModal = ({ open, onClose, onSelectGoal, modalTitle, modalDescription }) => {
    const [hoveredCard, setHoveredCard] = useState(null);

    const handleSubmit = async (selected) => {
        await onSelectGoal(selected);
        onClose();
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={style}>
                <MDBox textAlign="center" mb={4}>
                    <MDTypography variant="h4" fontWeight="bold" >
                        {modalTitle}
                    </MDTypography>
                    <Typography variant="body1" color="secondary">
                        {modalDescription}
                    </Typography>
                </MDBox>

                <Grid container spacing={3} justifyContent="center">
                    {goalOptions.map((option) => (
                        <Grid item xs={12} sm={6} md={4} key={option.value}>
                            <GoalOptionCard
                                option={option}
                                hoveredCard={hoveredCard}
                                setHoveredCard={setHoveredCard}
                                handleSubmit={handleSubmit}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Modal>
    );
};

export default CourseGoalModal;
